"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef } from "react";
import { Search, X, Loader2 } from "lucide-react";
import { useLabels } from "@/lib/labels/LabelsProvider";
interface SearchBarProps {
  query: string;
  onChange: (q: string) => void;
  loading: boolean;
  countSummary?: string | null;
}
export function SearchBar(t0) {
  const $ = _c(23);
  const {
    query,
    onChange,
    loading,
    countSummary
  } = t0;
  const labels = useLabels();
  const inputRef = useRef(null);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      inputRef.current?.focus();
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== loading) {
    t3 = loading ? <Loader2 className="w-6 h-6 shrink-0 text-muted-foreground animate-spin" /> : <Search className="w-6 h-6 shrink-0 text-muted-foreground" />;
    $[2] = loading;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onChange) {
    t4 = e => onChange(e.target.value);
    $[4] = onChange;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = labels.search?.placeholder || "Search teams, players, competitions and articles...";
  let t6;
  if ($[6] !== query || $[7] !== t4 || $[8] !== t5) {
    t6 = <input ref={inputRef} type="text" value={query} onChange={t4} placeholder={t5} className="flex-1 bg-transparent border-none outline-none text-xl md:text-2xl text-foreground placeholder:text-muted-foreground" autoComplete="off" />;
    $[6] = query;
    $[7] = t4;
    $[8] = t5;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] !== labels.common?.close || $[11] !== onChange || $[12] !== query) {
    t7 = query && <button type="button" onClick={() => onChange("")} className="p-1.5 rounded-full hover:bg-muted transition cursor-pointer text-muted-foreground" aria-label={labels.common?.close || "Clear"}><X className="w-5 h-5" /></button>;
    $[10] = labels.common?.close;
    $[11] = onChange;
    $[12] = query;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== t3 || $[15] !== t6 || $[16] !== t7) {
    t8 = <div className="flex items-center gap-3 border-b-2 border-border focus-within:border-primary transition-colors py-4">{t3}{t6}{t7}</div>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== countSummary) {
    t9 = countSummary && <div className="mt-3 text-sm text-muted-foreground">{countSummary}</div>;
    $[18] = countSummary;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== t8 || $[21] !== t9) {
    t10 = <div>{t8}{t9}</div>;
    $[20] = t8;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  return t10;
}